import api from "./api";
import { ok, isoUtc } from "./core";

export async function listAccounts() {
  const rows = [];
  for (let offset = 0; offset < 5000; offset += 200) {
    const { data } = await api.get("/accounts", { params: { limit: 200, offset } });
    rows.push(...data);
    if (data.length < 200) break;
  }
  return ok(rows.map((a) => ({
    employeeId: a.employee_id,
    username: a.username,
    active: Boolean(a.is_active),
    mustChangePassword: Boolean(a.must_change_password),
    lockedUntil: isoUtc(a.locked_until),
    createdAt: isoUtc(a.created_at),
  })));
}

export const createAccount = ({ employeeId, username, password, reason }) =>
  api.post("/accounts", { employee_id: employeeId, username, password, reason: reason || "Login account created" });

export const setAccountActive = (employeeId, isActive, reason) =>
  api.patch(`/accounts/${employeeId}/status`, { is_active: isActive, reason: reason || (isActive ? "Login allowed" : "Login blocked") });

export const resetAccountPassword = (employeeId, newPassword, reason) =>
  api.post(`/accounts/${employeeId}/reset-password`, { new_password: newPassword, reason: reason || "Temporary password issued" });

export function generateTemporaryPassword() {
  const upper = "ABCDEFGHJKLMNPQRSTUVWXYZ";
  const lower = "abcdefghijkmnopqrstuvwxyz";
  const digits = "23456789";
  const special = "!@#%";
  const chars = upper + lower + digits + special;
  const values = new Uint32Array(16);
  window.crypto.getRandomValues(values);
  const required = [upper[values[0] % upper.length], lower[values[1] % lower.length],
    digits[values[2] % digits.length], special[values[3] % special.length]];
  const rest = Array.from(values.slice(4), (v) => chars[v % chars.length]);
  const password = required.concat(rest);
  for (let i = password.length - 1; i > 0; i -= 1) {
    const j = values[i % values.length] % (i + 1);
    [password[i], password[j]] = [password[j], password[i]];
  }
  return password.join("");
}
